import { render, staticRenderFns } from "./VertBarChart.vue?vue&type=template&id=bc4f5c1c&scoped=true"
import script from "./VertBarChart.vue?vue&type=script&lang=js"
export * from "./VertBarChart.vue?vue&type=script&lang=js"
import style0 from "./VertBarChart.vue?vue&type=style&index=0&id=bc4f5c1c&prod&scoped=true&lang=css"
import style1 from "./VertBarChart.vue?vue&type=style&index=1&id=bc4f5c1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4f5c1c",
  null
  
)

export default component.exports